<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :server-items-length="meta.total"
      :footer-props="footerProps"
      :options="options"
      :page="page"
      :items-per-page="itemsPerPage"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :multi-sort="multiSort"
      v-on="listeners"
    >
      <template v-slot:item.action="{ item }">
        <div class="text-center">
          <v-list-item @click="show(item)">
            <v-list-item-title>
              <v-icon class="mr-1" small>mdi-eye</v-icon>
              {{ $t('ITEM.VIEW') }}
            </v-list-item-title>
          </v-list-item>
        </div>
      </template>

      <template v-slot:item.start="{ item }">
        {{ item.start | dateFormat }}
      </template>

      <template v-slot:item.end="{ item }">
        {{ item.end | dateFormat }}
      </template>

      <template v-slot:item.service="{ item }">
        {{ getFromItem(item, 'service.name') }}
      </template>

      <template v-slot:item.period="{ item }">
        {{ getFromItem(item, 'period.name') }}
      </template>

      <template v-slot:item.business_customer="{ item }">
        {{ getFromItem(item, 'building_complex.business_customer.name') }}
      </template>

      <template v-slot:item.management_company="{ item }">
        {{ getFromItem(item, 'building_complex.management_company.name') }}
      </template>

      <template v-slot:item.building_complex="{ item }">
        <span class="mr-2">{{ item.building_complex.name }}</span>
        <router-link
          v-if="item.building_complex_id"
          class="text-decoration-none"
          target="_blank"
          :to="{
            name: 'building_complexes.show',
            params: { id: item.building_complex_id }
          }"
        >
          <v-tooltip class="px-1" top>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">
                mdi-eye-outline
              </v-icon>
            </template>
            <span v-if="item.building_complex_name">{{
              item.building_complex_name
            }}</span>
            <span v-else>{{ $t('ITEM.VIEW') }}</span>
          </v-tooltip>
          <v-tooltip
            v-if="getFromItem(item, 'buildings').length"
            class="px-1"
            top
          >
            <template v-slot:activator="{ on }">
              <v-icon class="ml-2" small v-on="on">
                mdi-information-variant-circle-outline
              </v-icon>
            </template>
            <span style="max-width: 500px; float: left; word-wrap: break-word;">
              {{ $t('BUILDINGS.ITEMS') }}:
              <v-chip
                v-for="building in item.buildings"
                :key="building.id"
                class="ma-1"
              >
                {{ building.name }}
              </v-chip></span
            >
          </v-tooltip>
        </router-link>
      </template>

      <template v-slot:item.status_id="{ item }">
        <div v-if="!isEmptyObject(item.status)">
          <v-chip
            v-if="item.status.color"
            :color="item.status.color"
            text-color="white"
            small
          >
            {{ item.status.name }}
          </v-chip>
          <div v-else>
            {{ item.status.name }}
          </div>
        </div>
        <div v-else>
          {{ item.status }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { isEmpty, get } from 'lodash';
import { dateFormat } from '@/modules/_global/filters';
import listItems from '@/modules/_global/mixins/list-items';

export default {
  name: 'BuildingComplexesContractsList',

  filters: {
    dateFormat
  },

  mixins: [listItems],

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ABO_SERVICES.ITEM'),
          value: 'service'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          value: 'building_complex'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.BUSINESS_CUSTOMER'),
          value: 'business_customer'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.MANAGEMENT_COMPANY'),
          value: 'management_company'
        },
        {
          text: this.$t('SUBSCRIPTIONS.BILLING_PERIOD'),
          value: 'period'
        },
        {
          text: this.$t('CONTRACTS.CONTR_STARTS'),
          value: 'start'
        },
        {
          text: this.$t('CONTRACTS.CONTR_ENDS'),
          value: 'end'
        },
        {
          text: this.$t('ITEM.STATUS'),
          value: 'status_id'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          align: 'center',
          sortable: false
        }
      ];
    }
  },

  methods: {
    show(item) {
      this.$emit('show', item);
    },

    getFromItem(item, path) {
      return get(item, path, '');
    },

    isEmptyObject(v) {
      return isEmpty(v);
    }
  }
};
</script>
